import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6d68d3bc"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "new-kyc-form",
  style: {"position":"relative","padding":"3px 20px"},
  class: "font"
}
const _hoisted_2 = { class: "d-flex flex-flow justify-content-between" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    style: {"width":"150px","height":"35px"},
    src: "/images/logos/logo.png"
  })
], -1))
const _hoisted_4 = { class: "fs-11" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-end" }, "Licensed Financial Institution", -1))
const _hoisted_6 = { class: "d-flex text-end mt-1" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Account 账号 #:", -1))
const _hoisted_8 = { class: "ms-2" }
const _hoisted_9 = { style: {"text-decoration":"underline"} }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-center mt-11 mb-11" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, " KYC EVIDENCE VERIFICATION FORM / 客户信息核实证明表 "),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-1" }, "Bacera Co Pty Ltd"),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-3" }, " For Individuals, Individual Beneficial Owners and Sole Traders "),
  /*#__PURE__*/_createElementVNode("div", { class: "fs-3" }, "供个人,个人实益拥有者和个体经营者使用")
], -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, " I. Collection of Minimum KYC Information 客户基础信息采集 ", -1))
const _hoisted_12 = { style: {"width":"100%"} }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Surname"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "姓")
], -1))
const _hoisted_14 = { class: "kyc-input-col-3" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Given Name:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "名")
], -1))
const _hoisted_16 = { class: "kyc-input-col-3" }
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Prior Name"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "曾用名")
], -1))
const _hoisted_18 = { class: "kyc-input-col-3" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of Birth"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "出生日期")
], -1))
const _hoisted_20 = { class: "kyc-input-col-3" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Residential Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "居住地址")
], -1))
const _hoisted_22 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "AU Citizen or hold a passport from another country?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "澳大利亚联邦公民或持有他国护照?")
], -1))
const _hoisted_24 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_25 = { style: {"font-size":"12px"} }
const _hoisted_26 = { class: "d-flex align-items-center mb-3" }
const _hoisted_27 = ["checked"]
const _hoisted_28 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "AU Citizen 澳大利亚联邦公民", -1))
const _hoisted_29 = { class: "d-flex" }
const _hoisted_30 = { class: "d-flex align-items-center" }
const _hoisted_31 = ["checked"]
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Foreign Passport Holder 外国护照持有人", -1))
const _hoisted_33 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_34 = { style: {"font-size":"12px"} }
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_36 = {
  class: "ms-2",
  style: {"text-transform":"uppercase"}
}
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "E-mail Address"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "电子邮箱")
], -1))
const _hoisted_38 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Industry of Employment"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "工作行业")
], -1))
const _hoisted_40 = { class: "kyc-input-col-3" }
const _hoisted_41 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Position"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "职位")
], -1))
const _hoisted_42 = { class: "kyc-input-col-3" }
const _hoisted_43 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Annual Income"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "年收入")
], -1))
const _hoisted_44 = { class: "kyc-input-col-3" }
const _hoisted_45 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  rowspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "How might you fund your trading:"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "投资资金来源")
], -1))
const _hoisted_46 = {
  rowspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_47 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Savings and Investments"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "储蓄与投资价值")
], -1))
const _hoisted_48 = { class: "kyc-input-col-3" }
const _hoisted_49 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Have you ever attended an education seminar or course on trading Stocks, Bonds, Contracts-for-difference, Forex, Derivatives, or other securities trading?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您是否参加过有关股票,债券,差价合约,外汇,衍生品或其他证券交易的教育研讨会或课程?")
], -1))
const _hoisted_50 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_51 = { class: "d-flex align-items-center mb-3" }
const _hoisted_52 = ["checked"]
const _hoisted_53 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "YES/是", -1))
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = ["checked"]
const _hoisted_56 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_57 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Do you have previous experience trading in a Stocks, Bonds, Contracts-for-difference, Forex, Derivatives, or other securities trading account?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您之前是否有过股票,债券,差价合约,外汇,衍生品或其他证券交易账户的交易经验?")
], -1))
const _hoisted_58 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_59 = { class: "d-flex align-items-center mb-3" }
const _hoisted_60 = ["checked"]
const _hoisted_61 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "YES/是", -1))
const _hoisted_62 = { class: "d-flex align-items-center" }
const _hoisted_63 = ["checked"]
const _hoisted_64 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_65 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Are you an employee of BCR or another Financial Company?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您是 BCR 或其他金融公司的员工吗?")
], -1))
const _hoisted_66 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_67 = { style: {"font-size":"12px"} }
const _hoisted_68 = { class: "d-flex align-items-center" }
const _hoisted_69 = ["checked"]
const _hoisted_70 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Yes Please list the previous financial firms where you have been employeed / 是, 请列出您工作過的金融公司 ", -1))
const _hoisted_71 = { class: "ms-4 mt-3" }
const _hoisted_72 = { class: "mt-2" }
const _hoisted_73 = { class: "ms-3" }
const _hoisted_74 = { class: "mt-2" }
const _hoisted_75 = { class: "ms-3" }
const _hoisted_76 = { class: "mt-2" }
const _hoisted_77 = { class: "ms-3" }
const _hoisted_78 = { class: "d-flex align-items-center" }
const _hoisted_79 = ["checked"]
const _hoisted_80 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_81 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Have you declared bankruptcy in the past 10 years?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您在过去 10 年内是否曾宣告破产?")
], -1))
const _hoisted_82 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_83 = { style: {"font-size":"12px"} }
const _hoisted_84 = { class: "d-flex align-items-center" }
const _hoisted_85 = ["checked"]
const _hoisted_86 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode(" Yes, please indicate the date of discharge and provide a copy of the discharge letter with your application tip. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode(" / 是的,请注明出院日期并提供出院信副本以及您的申请提示. ")
], -1))
const _hoisted_87 = { class: "ms-8 mt-3 mb-3" }
const _hoisted_88 = { class: "ms-3" }
const _hoisted_89 = { class: "d-flex align-items-center" }
const _hoisted_90 = ["checked"]
const _hoisted_91 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_92 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  colspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "Are you or any person having an interest in this account a member or employee of a commodity exchange or regulatory agency?"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "您或任何对此账户感兴趣的人是否是商品交易所或监管机构的成员或雇员?")
], -1))
const _hoisted_93 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_94 = { style: {"font-size":"12px"} }
const _hoisted_95 = { class: "d-flex align-items-center mb-3" }
const _hoisted_96 = ["checked"]
const _hoisted_97 = { class: "ms-3" }
const _hoisted_98 = { class: "d-flex align-items-center" }
const _hoisted_99 = ["checked"]
const _hoisted_100 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_101 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  rowspan: "2",
  class: "kyc-label-col-2"
}, [
  /*#__PURE__*/_createElementVNode("span", null, "PEP"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "政治敏感人物")
], -1))
const _hoisted_102 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "kyc-input-col-3",
  style: {"font-size":"12px"}
}, [
  /*#__PURE__*/_createTextVNode(" Are you a Politically Exposed Person (PEP)? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("您是政治公众人物 (PEP) 吗? ")
], -1))
const _hoisted_103 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_104 = { style: {"font-size":"12px"} }
const _hoisted_105 = { class: "d-flex align-items-center mb-3" }
const _hoisted_106 = ["checked"]
const _hoisted_107 = { class: "ms-3" }
const _hoisted_108 = { class: "d-flex align-items-center" }
const _hoisted_109 = ["checked"]
const _hoisted_110 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_111 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", {
  class: "kyc-input-col-3",
  style: {"font-size":"12px"}
}, [
  /*#__PURE__*/_createTextVNode(" Are you an immediate family member or close associate of a PEP? "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("您是否有直系亲属或近亲属于政治敏感人物? ")
], -1))
const _hoisted_112 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_113 = { style: {"font-size":"12px"} }
const _hoisted_114 = { class: "d-flex align-items-center mb-3" }
const _hoisted_115 = ["checked"]
const _hoisted_116 = { class: "ms-3" }
const _hoisted_117 = { class: "d-flex align-items-center" }
const _hoisted_118 = ["checked"]
const _hoisted_119 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "NO/否", -1))
const _hoisted_120 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-11 mb-11" }, null, -1))
const _hoisted_121 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("strong", null, "For Sole Trader Only"),
  /*#__PURE__*/_createTextVNode("/仅供个体经营者 ")
], -1))
const _hoisted_122 = { style: {"width":"100%"} }
const _hoisted_123 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Full Business Name"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "公司全稱")
], -1))
const _hoisted_124 = { class: "kyc-input-col-3" }
const _hoisted_125 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Business Number"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "商務號碼")
], -1))
const _hoisted_126 = { class: "kyc-input-col-3" }
const _hoisted_127 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Full Business Address ( No PO Box )"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "辦公地址")
], -1))
const _hoisted_128 = { class: "kyc-input-col-3" }
const _hoisted_129 = {
  colspan: "2",
  class: "kyc-input-col-3"
}
const _hoisted_130 = {
  class: "d-flex",
  style: {"font-size":"12px"}
}
const _hoisted_131 = { style: {"width":"50%"} }
const _hoisted_132 = { class: "d-flex align-items-center" }
const _hoisted_133 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("City/Suburb"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("城市")
], -1))
const _hoisted_134 = { class: "ms-5 fs-3" }
const _hoisted_135 = { class: "d-flex align-items-center" }
const _hoisted_136 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Zip/Postal"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("邮编")
], -1))
const _hoisted_137 = { class: "ms-5 fs-3" }
const _hoisted_138 = { style: {"width":"50%"} }
const _hoisted_139 = { class: "d-flex align-items-center" }
const _hoisted_140 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("State/Territory"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("州 / 省")
], -1))
const _hoisted_141 = { class: "ms-5 fs-3" }
const _hoisted_142 = { class: "d-flex align-items-center" }
const _hoisted_143 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Country"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("国家")
], -1))
const _hoisted_144 = { class: "ms-5 fs-3" }
const _hoisted_145 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Nature and purpose of the business relationship between BCR and the client"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "BCR与客户之间业务关系的性质和目的")
], -1))
const _hoisted_146 = { class: "kyc-input-col-3" }
const _hoisted_147 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Reason for the client requiring our services (incl. supporting documents, e.g. overseas suppliers’ invoices)"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户需要我方提供服务的原因(包括支持文件,例如海外供应商的发票)")
], -1))
const _hoisted_148 = { class: "kyc-input-col-3" }
const _hoisted_149 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Industry in which the client operates"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户经营所属行业")
], -1))
const _hoisted_150 = { class: "kyc-input-col-3" }
const _hoisted_151 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, " The main 3 industries in which the client’s customers operate"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户的客人所属的3个主要行业")
], -1))
const _hoisted_152 = { class: "kyc-input-col-3" }
const _hoisted_153 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "1.", -1))
const _hoisted_154 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "2.", -1))
const _hoisted_155 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "me-3" }, "3.", -1))
const _hoisted_156 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "An explanation of a typical service provided by the client to its customers"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "客户向其客人提供的一项典型服务的详细描述")
], -1))
const _hoisted_157 = {
  colspan: "3",
  class: "kyc-input-col-8"
}
const _hoisted_158 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-11" }, "II. Verification/ 客户信息核实", -1))
const _hoisted_159 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, " At a minimum, CLIENTS’ FULL NAME and either their DATE OF BIRTH or RESIDENTIAL ADDRESS must be verified. "),
  /*#__PURE__*/_createElementVNode("div", null, "最低限度,客户姓名和出生日期或住址必须核实.")
], -1))
const _hoisted_160 = { style: {"width":"100%"} }
const _hoisted_161 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Type of Document"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "⽂件类型")
], -1))
const _hoisted_162 = { class: "kyc-input-col-3" }
const _hoisted_163 = { key: 0 }
const _hoisted_164 = { key: 1 }
const _hoisted_165 = { key: 2 }
const _hoisted_166 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Document ID number"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "⽂件号码")
], -1))
const _hoisted_167 = { class: "kyc-input-col-3" }
const _hoisted_168 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of birth"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "出生日期")
], -1))
const _hoisted_169 = { class: "kyc-input-col-3" }
const _hoisted_170 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Place of residence"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "居住地址")
], -1))
const _hoisted_171 = { class: "kyc-input-col-3" }
const _hoisted_172 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date of Issue"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签发日期")
], -1))
const _hoisted_173 = { class: "kyc-input-col-3" }
const _hoisted_174 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Expiry"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "过期日")
], -1))
const _hoisted_175 = { class: "kyc-input-col-3" }
const _hoisted_176 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-11 mb-5" }, "Verification Method/ 核实方法", -1))
const _hoisted_177 = { style: {"width":"100%"} }
const _hoisted_178 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Verification Method"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "核实方法")
], -1))
const _hoisted_179 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_180 = { class: "d-flex align-items-center mb-3" }
const _hoisted_181 = ["checked"]
const _hoisted_182 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Traditional Verification/传统核实", -1))
const _hoisted_183 = { class: "d-flex align-items-center" }
const _hoisted_184 = ["checked"]
const _hoisted_185 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "me-2" }, "Electronic Verification/电子核实", -1))
const _hoisted_186 = { class: "d-flex align-items-center ms-2" }
const _hoisted_187 = ["checked"]
const _hoisted_188 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "LAB group", -1))
const _hoisted_189 = { class: "d-flex align-items-center ms-2 me-2" }
const _hoisted_190 = ["checked"]
const _hoisted_191 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Data Zoo", -1))
const _hoisted_192 = { class: "d-flex align-items-center ms-2 me-2" }
const _hoisted_193 = ["checked"]
const _hoisted_194 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Refinitiv", -1))
const _hoisted_195 = {
  class: "mt-7",
  style: {"width":"100%"}
}
const _hoisted_196 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tr", { class: "text-center fw-bold" }, [
  /*#__PURE__*/_createElementVNode("td", {
    class: "kyc-label-col-5",
    style: {"font-size":"14px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Traditional Verification/传统核实")
  ]),
  /*#__PURE__*/_createElementVNode("td", {
    class: "kyc-label-col-5",
    style: {"font-size":"14px"}
  }, [
    /*#__PURE__*/_createElementVNode("span", null, "Electronic Verification/电子核实")
  ])
], -1))
const _hoisted_197 = {
  class: "kyc-input-col-5",
  style: {"font-size":"12px"}
}
const _hoisted_198 = { class: "d-flex align-items-center" }
const _hoisted_199 = ["checked"]
const _hoisted_200 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Verification method 1/核实方法1", -1))
const _hoisted_201 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-6" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Original or certified copy of a primary photographic identification document/ "),
  /*#__PURE__*/_createElementVNode("div", null, "首要的含照片身份证明文件的原始件或经认证的复印/")
], -1))
const _hoisted_202 = { class: "d-flex align-items-center mt-3" }
const _hoisted_203 = ["checked"]
const _hoisted_204 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("strong", null, "Verification method 2/核实方法2", -1))
const _hoisted_205 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-6" }, [
  /*#__PURE__*/_createElementVNode("div", null, " Original or certified copy of a primary non-photographic identification document; AND/OR "),
  /*#__PURE__*/_createElementVNode("div", null, " 首要的不含照片的身份证明文件原始件或经认证的复印件; 以及/或 "),
  /*#__PURE__*/_createElementVNode("div", null, " Original or certified copy of a secondary identification document; "),
  /*#__PURE__*/_createElementVNode("div", null, "二级身份证明文件的原始件或经认证的复印;")
], -1))
const _hoisted_206 = {
  class: "kyc-input-col-5",
  style: {"font-size":"12px"}
}
const _hoisted_207 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-3" }, [
  /*#__PURE__*/_createElementVNode("strong", null, [
    /*#__PURE__*/_createTextVNode("Verify information collected about a client from: "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("收集的关于核实客户信息来源于:")
  ])
], -1))
const _hoisted_208 = { class: "d-flex align-items-center" }
const _hoisted_209 = ["checked"]
const _hoisted_210 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-3" }, [
  /*#__PURE__*/_createTextVNode(" Reliable and independent documentation "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("可靠且独立的文件 ")
], -1))
const _hoisted_211 = { class: "d-flex align-items-center mt-3" }
const _hoisted_212 = ["checked"]
const _hoisted_213 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" Reliable and independent electronic data from at least two (2) separate data source "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("来自至少两 (2) 个单独数据源的可靠且独立的电子数据 ")
  ])
], -1))
const _hoisted_214 = { class: "d-flex align-items-center mt-3" }
const _hoisted_215 = ["checked"]
const _hoisted_216 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "ms-3" }, [
  /*#__PURE__*/_createElementVNode("div", null, [
    /*#__PURE__*/_createTextVNode(" A combination of both of the above "),
    /*#__PURE__*/_createElementVNode("br"),
    /*#__PURE__*/_createTextVNode("上面两者结合 ")
  ])
], -1))
const _hoisted_217 = {
  class: "mt-7",
  style: {"width":"100%"}
}
const _hoisted_218 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Compliance Notes"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "合规部门备注")
], -1))
const _hoisted_219 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"16px","color":"#900000"}
}
const _hoisted_220 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mt-12" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "mb-5",
    style: {"font-weight":"bold"}
  }, [
    /*#__PURE__*/_createElementVNode("div", null, " Where a client cannot provide satisfactory evidence of identity: "),
    /*#__PURE__*/_createElementVNode("div", null, "当客户无法提供令人满意的身份证明时：")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", null, " Where a client does not possess and is unable to obtain the necessary information or evidence of identity, then in limited and exceptional cases, we may use alternative identity proofing process, which are commensurate with our risk-based systems and controls. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", null, " In these limited and exceptional cases, the matter will be referred to the AML/CTF compliance officer who may accept a self-attestation from the client, if they are not aware that the self-attestation is incorrect or misleading. The AML/CTF compliance officer will also designate the client as being high risk and will implement the appropriate level of ongoing customer due diligence procedures which is commensurate with a high risk client. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", null, " 如果客户不拥有且无法获得必要的身份信息或证明,那么在有限和例外的情况下,我们可能会使用替代性的身份证明流程,该流程与基于风险的系统和控制措施相符. ")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
    /*#__PURE__*/_createElementVNode("div", null, " 在这些有限和例外的情况下,此事将转给可能接受客户自我证明的AML / CTF合规官員, 如果他们不知道该自我证明是不正确或具有误导性.AML / CTF合规官还将指定客户为高风险客户,并将实施与高风险客户相对应的适当级别的持续客户尽职调查程序. ")
  ])
], -1))
const _hoisted_221 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "mt-11 mb-9",
  style: {"position":"relative"}
}, [
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "text-center",
    style: {"position":"absolute","top":"50%","left":"50%","transform":"translate(-50%, -50%)","background-color":"white","padding":"0px 10px 0px 18px"}
  }, [
    /*#__PURE__*/_createElementVNode("strong", null, "For Office Use Only/本公司专用（请勿填写）")
  ])
], -1))
const _hoisted_222 = { class: "d-flex justify-content-around" }
const _hoisted_223 = { style: {"width":"48%"} }
const _hoisted_224 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Admin Staff Member"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "办公室员工")
], -1))
const _hoisted_225 = { class: "kyc-input-col-3" }
const _hoisted_226 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Position"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "职位")
], -1))
const _hoisted_227 = { class: "kyc-input-col-3" }
const _hoisted_228 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Signature"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签名")
], -1))
const _hoisted_229 = { class: "kyc-input-col-3" }
const _hoisted_230 = ["src"]
const _hoisted_231 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date Signed"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签字日期")
], -1))
const _hoisted_232 = { class: "kyc-input-col-3" }
const _hoisted_233 = { style: {"width":"48%"} }
const _hoisted_234 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Compliance Staff Member"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "合规部门员工")
], -1))
const _hoisted_235 = { class: "kyc-input-col-3" }
const _hoisted_236 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Position"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "职位")
], -1))
const _hoisted_237 = { class: "kyc-input-col-3" }
const _hoisted_238 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Signature"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签名")
], -1))
const _hoisted_239 = { class: "kyc-input-col-3" }
const _hoisted_240 = ["src"]
const _hoisted_241 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Date Signed"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "签字日期")
], -1))
const _hoisted_242 = { class: "kyc-input-col-3" }
const _hoisted_243 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-11 mb-11" }, null, -1))
const _hoisted_244 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mb-5" }, [
  /*#__PURE__*/_createElementVNode("div", null, "COPY OF SUPPORTING DOCUMENTATION"),
  /*#__PURE__*/_createElementVNode("div", null, "支持性⽂件复印件")
], -1))
const _hoisted_245 = { width: "100%" }
const _hoisted_246 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "kyc-label-col-2" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Type of Document"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", null, "⽂件类型")
], -1))
const _hoisted_247 = {
  colspan: "3",
  class: "kyc-input-col-8",
  style: {"font-size":"12px"}
}
const _hoisted_248 = { class: "d-flex align-items-center mb-3" }
const _hoisted_249 = ["checked"]
const _hoisted_250 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Passport (Country of Origin)/护照（原籍国）", -1))
const _hoisted_251 = { class: "d-flex align-items-center mb-3" }
const _hoisted_252 = ["checked"]
const _hoisted_253 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Photo ID / DL (Country of Origin)/含照片身份证件/驾照（原籍国） ", -1))
const _hoisted_254 = { class: "d-flex align-items-center" }
const _hoisted_255 = ["checked"]
const _hoisted_256 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, " Financial Statement/Utility Bill/Government Document/ 财务证明/水电费账单/政府文件 ", -1))
const _hoisted_257 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", { class: "mt-11 mb-11" }, null, -1))
const _hoisted_258 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "my-8" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-semibold mb-6 tracking-widerr" }, [
    /*#__PURE__*/_createElementVNode("div", null, " You must verify the CLIENT’S FULL NAME and either their DATE OF BIRTH or RESIDENTIAL ADDRESS using: "),
    /*#__PURE__*/_createElementVNode("div", null, "您必须利用以下资料确认客户姓名和出生日期或住址信息:")
  ]),
  /*#__PURE__*/_createElementVNode("div", {
    class: "p-4",
    style: {"border":"1px solid lightgray"}
  }, [
    /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-semibold mb-4 tracking-widerr" }, [
      /*#__PURE__*/_createElementVNode("div", null, " AN ORIGINAL OR CERTIFIED COPY OF A PRIMARY PHOTOGRAPHIC IDENTIFICATION DOCUMENT "),
      /*#__PURE__*/_createElementVNode("div", null, "一份含照⽚的首要身份证明⽂件原始件或认证的复印件")
    ]),
    /*#__PURE__*/_createElementVNode("div", { class: "px-8" }, [
      /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-outside text-3xs" }, [
        /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
          /*#__PURE__*/_createElementVNode("div", null, " A license or permit issued under a law of a State or Territory or equivalent authority of a foreign country for the purpose of driving a vehicle that contains a photograph of the person in whose name the document is issued; "),
          /*#__PURE__*/_createElementVNode("div", null, " 州或领地或其他外国的政府或同等权威机构颁发的含申请人姓名及照⽚的用于驾驶车辆的许可证件; ")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
          /*#__PURE__*/_createElementVNode("div", null, "a passport issued by the Commonwealth;"),
          /*#__PURE__*/_createElementVNode("div", null, "联邦颁发的护照;")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
          /*#__PURE__*/_createElementVNode("div", null, " a passport or a similar document issued for the purpose of international travel, that: "),
          /*#__PURE__*/_createElementVNode("div", null, "护照或其他和护照性质一样用于国际旅行的⽂件:"),
          /*#__PURE__*/_createElementVNode("div", { class: "px-8" }, [
            /*#__PURE__*/_createElementVNode("ol", { class: "list-decimal list-outside text-3xs" }, [
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("div", null, " Contains a photograph and the signature of the person in whose the document is issued; "),
                /*#__PURE__*/_createElementVNode("div", null, "签发的⽂件需包含申请人照⽚和签名;")
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("div", null, " is issued by a foreign government, the United Nations or an agency of the United Nations; and "),
                /*#__PURE__*/_createElementVNode("div", null, "由外国政府, 联合国或联合国所属机构颁发, 以及")
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("div", null, " if it is written in a language that is not understood by the person carrying out the the verification – is accompanied by an English translation prepared by an accredit translator. "),
                /*#__PURE__*/_createElementVNode("div", null, " 如果进行验证的人对⽂件所用语言并不了解或认知,需由授权翻译机构翻译成英⽂. ")
              ])
            ])
          ])
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
          /*#__PURE__*/_createElementVNode("div", null, " A card issued under the law of a State or Territory for the purpose of proving the person’s age which contains a photograph of the person in whose name the document is issued. "),
          /*#__PURE__*/_createElementVNode("div", null, " 按照州或领地法律颁发的用于证明申请人年龄的包含申请人照⽚及姓名的证件. ")
        ]),
        /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
          /*#__PURE__*/_createElementVNode("div", null, " A national identity card issued for the purpose of identification, that: "),
          /*#__PURE__*/_createElementVNode("div", null, "用于识别身份的国民身份证:"),
          /*#__PURE__*/_createElementVNode("div", { class: "px-8" }, [
            /*#__PURE__*/_createElementVNode("ol", { class: "list-decimal list-outside text-3xs mx-2" }, [
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("div", null, " Contains a photograph and a signature of the person in whose name the document is issued; "),
                /*#__PURE__*/_createElementVNode("div", null, "包含申请人照⽚和签名;")
              ]),
              /*#__PURE__*/_createElementVNode("li", null, [
                /*#__PURE__*/_createElementVNode("div", null, " is issued by a foreign government, the United Nations or an agency of the United Nations if it is written in a language that is not understood by the person carrying out the verification – is accompanied by an English translation prepared by an accredit translator. "),
                /*#__PURE__*/_createElementVNode("div", null, " 由外国政府, 联合国或联合国所属机构颁发, 如进行验证的人对⽂件所用语言并不了解或认知, 需由授权翻译机构翻译成英⽂. ")
              ])
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_259 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-semibold text-center w-full tracking-widerr mb-7" }, " OR / 或 ", -1))
const _hoisted_260 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "p-4",
  style: {"border":"1px solid lightgray"}
}, [
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-semibold mb-4 tracking-widerr" }, [
    /*#__PURE__*/_createElementVNode("div", null, " AN ORIGINAL OR CERTIFIED COPY OF A PRIMARY PHOTOGRAPHIC IDENTIFICATION DOCUMENT "),
    /*#__PURE__*/_createElementVNode("div", null, "一份含照⽚的首要身份证明⽂件原始件或认证的复印件")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "px-8" }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-outside text-3xs" }, [
      /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, " A birth certificate or birth extract issued by a State or Territory; "),
        /*#__PURE__*/_createElementVNode("div", null, "由州或领地颁发的出生证明或出生信息摘要;")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, "a citizenship certificate issued by the Commonwealth;"),
        /*#__PURE__*/_createElementVNode("div", null, "由联邦颁发的公民证明;")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, " a citizenship certificate issued by a foreign government that, if it is written in a language that is not understood by the person carrying out the verification, is accompanied by an English translation prepared by an accredited translator; "),
        /*#__PURE__*/_createElementVNode("div", null, " 由外国政府颁发的公民证明, 如进行验证的人对⽂件所用语言并不了解或认知, 需由授权翻译机构翻译成英⽂. ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, " a birth certificate issued by a foreign government, the United Nations or an agency of the United Nations that, if it is written in a language that is not understood by the person carrying out the verification, is accompanied by an English translation prepared by an accredited translator; "),
        /*#__PURE__*/_createElementVNode("div", null, " 由外国政府,联合国或联合国所属机构颁发的出生证明, 如进行验证的人对⽂件所用语言并不了解或认知, 需由授权翻译机构翻译成英⽂; ")
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, " a pension card issued by Centrelink that entitles the person in whose name the card is issued, to financial benefits. "),
        /*#__PURE__*/_createElementVNode("div", null, " 由centrelink发出的, 基于财务效益, 授予申请人的包含申请人姓名的养⽼金卡. ")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-semibold text-center w-full my-8 tracking-widerr" }, " AND / 以及 "),
  /*#__PURE__*/_createElementVNode("div", { class: "text-xs font-semibold mb-4 tracking-widerr" }, [
    /*#__PURE__*/_createElementVNode("div", null, " AN ORIGINAL OR CERTIFIED COPY OF A SECONDARY IDENTIFICATION DOCUMENT "),
    /*#__PURE__*/_createElementVNode("div", null, "一份含照⽚的二级身份证明⽂件原始件或认证的复印件")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "px-8" }, [
    /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-outside text-3xs" }, [
      /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, "A notice that / 一份声明:"),
        /*#__PURE__*/_createElementVNode("div", { class: "px-8" }, [
          /*#__PURE__*/_createElementVNode("ol", { class: "list-decimal list-outside text-3xs" }, [
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " was issued to an individual by the Commonwealth, a State or Territory within the preceding twelve months; "),
              /*#__PURE__*/_createElementVNode("div", null, "由聯邦或州或領地在前12個月內簽發給個人的;")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " contains the name of the individual and his or her residential address; and "),
              /*#__PURE__*/_createElementVNode("div", null, "包含個人姓名和他/她的住址信息; 以及")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " records the provision of financial benefits to the individual under a law of the Commonwealth, State or Territory (as the case may be); "),
              /*#__PURE__*/_createElementVNode("div", null, " 根據聯邦或州或領地法律提供個人財務收益的記錄(視情況而定); ")
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, "A notice that / 一份声明:"),
        /*#__PURE__*/_createElementVNode("div", { class: "px-8" }, [
          /*#__PURE__*/_createElementVNode("ol", { class: "list-decimal list-outside text-3xs" }, [
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " was issued to an individual by the Australian Taxation Office within the preceding 12 months; "),
              /*#__PURE__*/_createElementVNode("div", null, "由澳大利亞稅務機構在前12個月內簽發給個人的;")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " contains the name of the individual and his or her residential address; and "),
              /*#__PURE__*/_createElementVNode("div", null, "包含個人姓名和他/她的住址信息; 以及")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " records a debt payable to or by the individual by or to (respectively) the Commonwealth under Commonwealth law relating to taxation; "),
              /*#__PURE__*/_createElementVNode("div", null, "根據聯邦稅務相關法律關於個人債務支付的記錄;")
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, "A notice that / 一份声明:"),
        /*#__PURE__*/_createElementVNode("div", { class: "px-8" }, [
          /*#__PURE__*/_createElementVNode("ol", { class: "list-decimal list-outside text-3xs" }, [
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " was issued to an individual by a local government body or utilities provider within the preceding three months; "),
              /*#__PURE__*/_createElementVNode("div", null, "由當地政府或公共事業機構在前3個月內簽發給個人的;")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " contains the name of the individual and his or her residential address; and "),
              /*#__PURE__*/_createElementVNode("div", null, "包含個人姓名和他/她的住址信息; 以及")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " records the provision of services by that local government body or utilities provider to that address or to that person. "),
              /*#__PURE__*/_createElementVNode("div", null, " 由當地政府機構或公共事業機構對該住址或個人提供的服務記錄. ")
            ])
          ])
        ])
      ]),
      /*#__PURE__*/_createElementVNode("li", { class: "mb-2" }, [
        /*#__PURE__*/_createElementVNode("div", null, "A notice that / 一份声明:"),
        /*#__PURE__*/_createElementVNode("div", { class: "px-8" }, [
          /*#__PURE__*/_createElementVNode("ol", { class: "list-decimal list-outside text-3xs" }, [
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " was issued to a person by a school principal within the preceding three months; "),
              /*#__PURE__*/_createElementVNode("div", null, "由學校校長在前3個月之內簽發給個人的；")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " contains the name of the person and his or her residential address; and "),
              /*#__PURE__*/_createElementVNode("div", null, "包含個人姓名和他/她的住址信息; 以及")
            ]),
            /*#__PURE__*/_createElementVNode("li", null, [
              /*#__PURE__*/_createElementVNode("div", null, " records the period of time that the person attended at the school. "),
              /*#__PURE__*/_createElementVNode("div", null, "提供個人在校時間的記錄.")
            ])
          ])
        ])
      ])
    ])
  ])
], -1))
const _hoisted_261 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("footer", { class: "text-center mt-11" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Level 18, Suite 3, 201 Elizabeth Street, Sydney NSW, 2000"),
  /*#__PURE__*/_createElementVNode("p", null, "Bacera Co Pty Ltd | AU Company No. | License No.")
], -1))

import { ref } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import html2pdf from "html2pdf.js";

export default /*#__PURE__*/_defineComponent({
  __name: 'FinalizedKycModal',
  setup(__props, { expose: __expose }) {

const isLoading = ref(true);
const kycInfos = ref({} as any);
const formRef = ref<InstanceType<typeof SimpleForm> | null>(null);

const convertToPdf = async () => {
  isLoading.value = true;
  const element = document.getElementById("new-kyc-form") as HTMLElement;
  const opt = {
    margin: [0.5, 0.2],
    filename: "KYC Form.pdf",
    image: { type: "jpeg", quality: 0.98 },
    html2canvas: { scale: 2, useCORS: true, logging: true },
    jsPDF: { unit: "in", format: "letter", orientation: "portrait" },
  };

  await html2pdf().from(element).set(opt).save();
  isLoading.value = false;
};

const show = async (_kycInfos: any) => {
  formRef.value?.show();

  isLoading.value = true;
  kycInfos.value = _kycInfos;
  isLoading.value = false;
};

const hide = () => {
  formRef.value?.hide();
};

__expose({
  hide,
  show,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "formRef",
    ref: formRef,
    "is-loading": isLoading.value,
    title: '',
    "min-height": 775,
    "min-width": 1000,
    saveTitle: _ctx.$t('action.download'),
    submit: convertToPdf
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _hoisted_5,
            _createElementVNode("div", _hoisted_6, [
              _hoisted_7,
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("span", _hoisted_9, "   " + _toDisplayString(kycInfos.value.accountNumber) + "   ", 1)
              ])
            ])
          ])
        ]),
        _hoisted_10,
        _createElementVNode("div", null, [
          _hoisted_11,
          _createElementVNode("table", _hoisted_12, [
            _createElementVNode("tr", null, [
              _hoisted_13,
              _createElementVNode("td", _hoisted_14, _toDisplayString(kycInfos.value.lastName), 1),
              _hoisted_15,
              _createElementVNode("td", _hoisted_16, _toDisplayString(kycInfos.value.firstName), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_17,
              _createElementVNode("td", _hoisted_18, _toDisplayString(kycInfos.value.priorName), 1),
              _hoisted_19,
              _createElementVNode("td", _hoisted_20, _toDisplayString(kycInfos.value.birthday), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_21,
              _createElementVNode("td", _hoisted_22, _toDisplayString(kycInfos.value.address), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_23,
              _createElementVNode("td", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.citizen.toLowerCase() == 'au'
                    }, null, 8, _hoisted_27),
                    _hoisted_28
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _createElementVNode("div", null, [
                      _createElementVNode("div", _hoisted_30, [
                        _createElementVNode("input", {
                          class: "me-4",
                          type: "checkbox",
                          checked: kycInfos.value.citizen.toLowerCase() != 'au'
                        }, null, 8, _hoisted_31),
                        _hoisted_32
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("td", _hoisted_33, [
                _createElementVNode("div", _hoisted_34, [
                  _createTextVNode(" Please provide details "),
                  _hoisted_35,
                  _createTextVNode("请提供细节: "),
                  _createElementVNode("strong", _hoisted_36, _toDisplayString(kycInfos.value.citizen) + " Citizen", 1)
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_37,
              _createElementVNode("td", _hoisted_38, _toDisplayString(kycInfos.value.email), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_39,
              _createElementVNode("td", _hoisted_40, _toDisplayString(kycInfos.value.industry), 1),
              _hoisted_41,
              _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.$t("fields." + kycInfos.value.occupation)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_43,
              _createElementVNode("td", _hoisted_44, _toDisplayString(_ctx.$t("fields.range_" + kycInfos.value.annualIncome)), 1),
              _hoisted_45,
              _createElementVNode("td", _hoisted_46, _toDisplayString(kycInfos.value.sourceOfFunds), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_47,
              _createElementVNode("td", _hoisted_48, _toDisplayString(_ctx.$t("fields.range_" + kycInfos.value.netWorth)), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_49,
              _createElementVNode("td", _hoisted_50, [
                _createElementVNode("div", _hoisted_51, [
                  _createElementVNode("input", {
                    class: "me-4",
                    type: "checkbox",
                    checked: kycInfos.value.bg1 == 0
                  }, null, 8, _hoisted_52),
                  _hoisted_53
                ]),
                _createElementVNode("div", _hoisted_54, [
                  _createElementVNode("input", {
                    class: "me-4",
                    type: "checkbox",
                    checked: kycInfos.value.bg1 == 1
                  }, null, 8, _hoisted_55),
                  _hoisted_56
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_57,
              _createElementVNode("td", _hoisted_58, [
                _createElementVNode("div", _hoisted_59, [
                  _createElementVNode("input", {
                    class: "me-4",
                    type: "checkbox",
                    checked: kycInfos.value.bg2 == 0
                  }, null, 8, _hoisted_60),
                  _hoisted_61
                ]),
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("input", {
                    class: "me-4",
                    type: "checkbox",
                    checked: kycInfos.value.bg2 == 1
                  }, null, 8, _hoisted_63),
                  _hoisted_64
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_65,
              _createElementVNode("td", _hoisted_66, [
                _createElementVNode("div", _hoisted_67, [
                  _createElementVNode("div", _hoisted_68, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp1 == 0
                    }, null, 8, _hoisted_69),
                    _hoisted_70
                  ]),
                  _createElementVNode("div", _hoisted_71, [
                    _createElementVNode("ul", null, [
                      _createElementVNode("li", _hoisted_72, [
                        _createTextVNode(" Employer/公司 : "),
                        _createElementVNode("span", _hoisted_73, _toDisplayString(kycInfos.value.exp1Employer), 1)
                      ]),
                      _createElementVNode("li", _hoisted_74, [
                        _createTextVNode(" Position/職位 : "),
                        _createElementVNode("span", _hoisted_75, _toDisplayString(kycInfos.value.exp1Position), 1)
                      ]),
                      _createElementVNode("li", _hoisted_76, [
                        _createTextVNode(" Remuneration/报酬 : "),
                        _createElementVNode("span", _hoisted_77, _toDisplayString(kycInfos.value.exp1Remuneration), 1)
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_78, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp1 == 1
                    }, null, 8, _hoisted_79),
                    _hoisted_80
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_81,
              _createElementVNode("td", _hoisted_82, [
                _createElementVNode("div", _hoisted_83, [
                  _createElementVNode("div", _hoisted_84, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp2 == 0
                    }, null, 8, _hoisted_85),
                    _hoisted_86
                  ]),
                  _createElementVNode("div", _hoisted_87, [
                    _createTextVNode(" Date:"),
                    _createElementVNode("span", _hoisted_88, _toDisplayString(kycInfos.value.exp2More), 1)
                  ]),
                  _createElementVNode("div", _hoisted_89, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp2 == 1
                    }, null, 8, _hoisted_90),
                    _hoisted_91
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_92,
              _createElementVNode("td", _hoisted_93, [
                _createElementVNode("div", _hoisted_94, [
                  _createElementVNode("div", _hoisted_95, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp3 == 0
                    }, null, 8, _hoisted_96),
                    _createElementVNode("div", null, [
                      _createTextVNode(" Yes, please provide name(s) of Exchange or Agency. / 是, 请提供交易所或机构的名称:"),
                      _createElementVNode("span", _hoisted_97, _toDisplayString(kycInfos.value.exp3More), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_98, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp3 == 1
                    }, null, 8, _hoisted_99),
                    _hoisted_100
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_101,
              _hoisted_102,
              _createElementVNode("td", _hoisted_103, [
                _createElementVNode("div", _hoisted_104, [
                  _createElementVNode("div", _hoisted_105, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp4 == 0
                    }, null, 8, _hoisted_106),
                    _createElementVNode("div", null, [
                      _createTextVNode(" Yes Please provide details/是, 请提供细节:"),
                      _createElementVNode("span", _hoisted_107, _toDisplayString(kycInfos.value.exp4More), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_108, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp4 == 1
                    }, null, 8, _hoisted_109),
                    _hoisted_110
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_111,
              _createElementVNode("td", _hoisted_112, [
                _createElementVNode("div", _hoisted_113, [
                  _createElementVNode("div", _hoisted_114, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp5 == 0
                    }, null, 8, _hoisted_115),
                    _createElementVNode("div", null, [
                      _createTextVNode(" Yes Please provide details/是, 请提供细节:"),
                      _createElementVNode("span", _hoisted_116, _toDisplayString(kycInfos.value.exp5More), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_117, [
                    _createElementVNode("input", {
                      class: "me-4",
                      type: "checkbox",
                      checked: kycInfos.value.exp5 == 1
                    }, null, 8, _hoisted_118),
                    _hoisted_119
                  ])
                ])
              ])
            ])
          ]),
          _hoisted_120,
          _hoisted_121,
          _createElementVNode("table", _hoisted_122, [
            _createElementVNode("tr", null, [
              _hoisted_123,
              _createElementVNode("td", _hoisted_124, _toDisplayString(kycInfos.value.businessName), 1),
              _hoisted_125,
              _createElementVNode("td", _hoisted_126, _toDisplayString(kycInfos.value.businessNumber), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_127,
              _createElementVNode("td", _hoisted_128, _toDisplayString(kycInfos.value.businessAddress), 1),
              _createElementVNode("td", _hoisted_129, [
                _createElementVNode("div", _hoisted_130, [
                  _createElementVNode("div", _hoisted_131, [
                    _createElementVNode("div", _hoisted_132, [
                      _hoisted_133,
                      _createElementVNode("div", _hoisted_134, _toDisplayString(kycInfos.value.businessCity), 1)
                    ]),
                    _createElementVNode("div", _hoisted_135, [
                      _hoisted_136,
                      _createElementVNode("div", _hoisted_137, _toDisplayString(kycInfos.value.businessZipCode), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_138, [
                    _createElementVNode("div", _hoisted_139, [
                      _hoisted_140,
                      _createElementVNode("div", _hoisted_141, _toDisplayString(kycInfos.value.businessState), 1)
                    ]),
                    _createElementVNode("div", _hoisted_142, [
                      _hoisted_143,
                      _createElementVNode("div", _hoisted_144, _toDisplayString(kycInfos.value.businessCountry), 1)
                    ])
                  ])
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_145,
              _createElementVNode("td", _hoisted_146, _toDisplayString(kycInfos.value.businessCompanyPurposeBetweenUs), 1),
              _hoisted_147,
              _createElementVNode("td", _hoisted_148, _toDisplayString(kycInfos.value.businessServiceRequireReason), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_149,
              _createElementVNode("td", _hoisted_150, _toDisplayString(kycInfos.value.businessIndustry), 1),
              _hoisted_151,
              _createElementVNode("td", _hoisted_152, [
                _createElementVNode("div", null, [
                  _hoisted_153,
                  _createTextVNode(_toDisplayString(kycInfos.value.businessClientIndustry1), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_154,
                  _createTextVNode(_toDisplayString(kycInfos.value.businessClientIndustry2), 1)
                ]),
                _createElementVNode("div", null, [
                  _hoisted_155,
                  _createTextVNode(_toDisplayString(kycInfos.value.businessClientIndustry3), 1)
                ])
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_156,
              _createElementVNode("td", _hoisted_157, _toDisplayString(kycInfos.value.businessService), 1)
            ])
          ]),
          _hoisted_158,
          _hoisted_159,
          _createElementVNode("table", _hoisted_160, [
            _createElementVNode("tr", null, [
              _hoisted_161,
              _createElementVNode("td", _hoisted_162, [
                (kycInfos.value.idType == 1)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_163, "Passport"))
                  : _createCommentVNode("", true),
                (kycInfos.value.idType == 2)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_164, "Driver's License"))
                  : _createCommentVNode("", true),
                (kycInfos.value.idType == 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_165, "Government ID"))
                  : _createCommentVNode("", true)
              ]),
              _hoisted_166,
              _createElementVNode("td", _hoisted_167, _toDisplayString(kycInfos.value.idNumber), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_168,
              _createElementVNode("td", _hoisted_169, _toDisplayString(kycInfos.value.birthday), 1),
              _hoisted_170,
              _createElementVNode("td", _hoisted_171, _toDisplayString(kycInfos.value.address), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_172,
              _createElementVNode("td", _hoisted_173, _toDisplayString(kycInfos.value.idIssuedOn), 1),
              _hoisted_174,
              _createElementVNode("td", _hoisted_175, _toDisplayString(kycInfos.value.idExpireOn), 1)
            ])
          ]),
          _hoisted_176,
          _createElementVNode("table", _hoisted_177, [
            _createElementVNode("tr", null, [
              _hoisted_178,
              _createElementVNode("td", _hoisted_179, [
                _createElementVNode("div", _hoisted_180, [
                  _createElementVNode("input", {
                    class: "me-2",
                    type: "checkbox",
                    checked: kycInfos.value.electronicOrTraditional == 'traditional'
                  }, null, 8, _hoisted_181),
                  _hoisted_182
                ]),
                _createElementVNode("div", _hoisted_183, [
                  _createElementVNode("input", {
                    class: "me-2",
                    type: "checkbox",
                    checked: kycInfos.value.electronicOrTraditional == 'electronic'
                  }, null, 8, _hoisted_184),
                  _hoisted_185,
                  _createTextVNode(" ( "),
                  _createElementVNode("div", _hoisted_186, [
                    _createElementVNode("input", {
                      class: "me-2",
                      type: "checkbox",
                      checked: kycInfos.value.electronicSourceOption == 'labGroup'
                    }, null, 8, _hoisted_187),
                    _hoisted_188
                  ]),
                  _createElementVNode("div", _hoisted_189, [
                    _createElementVNode("input", {
                      class: "me-2",
                      type: "checkbox",
                      checked: kycInfos.value.electronicSourceOption == 'dataZoo'
                    }, null, 8, _hoisted_190),
                    _hoisted_191
                  ]),
                  _createElementVNode("div", _hoisted_192, [
                    _createElementVNode("input", {
                      class: "me-2",
                      type: "checkbox",
                      checked: kycInfos.value.electronicSourceOption == 'refinitiv'
                    }, null, 8, _hoisted_193),
                    _hoisted_194
                  ]),
                  _createTextVNode(" ) ")
                ])
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_195, [
            _hoisted_196,
            _createElementVNode("tr", null, [
              _createElementVNode("td", _hoisted_197, [
                _createElementVNode("div", _hoisted_198, [
                  _createElementVNode("input", {
                    class: "me-2",
                    type: "checkbox",
                    checked: kycInfos.value.traditionalOption == 'traditional1'
                  }, null, 8, _hoisted_199),
                  _hoisted_200
                ]),
                _hoisted_201,
                _createElementVNode("div", _hoisted_202, [
                  _createElementVNode("input", {
                    class: "me-2",
                    type: "checkbox",
                    checked: kycInfos.value.traditionalOption == 'traditional2'
                  }, null, 8, _hoisted_203),
                  _hoisted_204
                ]),
                _hoisted_205
              ]),
              _createElementVNode("td", _hoisted_206, [
                _hoisted_207,
                _createElementVNode("div", _hoisted_208, [
                  _createElementVNode("input", {
                    class: "me-2",
                    type: "checkbox",
                    checked: kycInfos.value.electronicOption == '0'
                  }, null, 8, _hoisted_209),
                  _hoisted_210
                ]),
                _createElementVNode("div", _hoisted_211, [
                  _createElementVNode("input", {
                    class: "me-2",
                    type: "checkbox",
                    checked: kycInfos.value.electronicOption == '1'
                  }, null, 8, _hoisted_212),
                  _hoisted_213
                ]),
                _createElementVNode("div", _hoisted_214, [
                  _createElementVNode("input", {
                    class: "me-2",
                    type: "checkbox",
                    checked: kycInfos.value.electronicOption == '2'
                  }, null, 8, _hoisted_215),
                  _hoisted_216
                ])
              ])
            ])
          ]),
          _createElementVNode("table", _hoisted_217, [
            _createElementVNode("tr", null, [
              _hoisted_218,
              _createElementVNode("td", _hoisted_219, _toDisplayString(kycInfos.value.complianceNote), 1)
            ])
          ]),
          _hoisted_220
        ]),
        _hoisted_221,
        _createElementVNode("div", _hoisted_222, [
          _createElementVNode("table", _hoisted_223, [
            _createElementVNode("tr", null, [
              _hoisted_224,
              _createElementVNode("td", _hoisted_225, _toDisplayString(kycInfos.value.staffName), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_226,
              _createElementVNode("td", _hoisted_227, _toDisplayString(kycInfos.value.staffPosition), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_228,
              _createElementVNode("td", _hoisted_229, [
                _createElementVNode("img", {
                  src: kycInfos.value.staffSignature,
                  height: "80",
                  alt: ""
                }, null, 8, _hoisted_230)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_231,
              _createElementVNode("td", _hoisted_232, _toDisplayString(kycInfos.value.staffSignedOn), 1)
            ])
          ]),
          _createElementVNode("table", _hoisted_233, [
            _createElementVNode("tr", null, [
              _hoisted_234,
              _createElementVNode("td", _hoisted_235, _toDisplayString(kycInfos.value.complianceName), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_236,
              _createElementVNode("td", _hoisted_237, _toDisplayString(kycInfos.value.compliancePosition), 1)
            ]),
            _createElementVNode("tr", null, [
              _hoisted_238,
              _createElementVNode("td", _hoisted_239, [
                _createElementVNode("img", {
                  src: kycInfos.value.complianceSignature,
                  height: "80",
                  alt: ""
                }, null, 8, _hoisted_240)
              ])
            ]),
            _createElementVNode("tr", null, [
              _hoisted_241,
              _createElementVNode("td", _hoisted_242, _toDisplayString(kycInfos.value.complianceSignedOn), 1)
            ])
          ])
        ]),
        _hoisted_243,
        _hoisted_244,
        _createElementVNode("table", _hoisted_245, [
          _createElementVNode("tr", null, [
            _hoisted_246,
            _createElementVNode("td", _hoisted_247, [
              _createElementVNode("div", _hoisted_248, [
                _createElementVNode("input", {
                  class: "me-2",
                  type: "checkbox",
                  checked: kycInfos.value.idType == '3'
                }, null, 8, _hoisted_249),
                _hoisted_250
              ]),
              _createElementVNode("div", _hoisted_251, [
                _createElementVNode("input", {
                  class: "me-2",
                  type: "checkbox",
                  checked: kycInfos.value.idType == '2'
                }, null, 8, _hoisted_252),
                _hoisted_253
              ]),
              _createElementVNode("div", _hoisted_254, [
                _createElementVNode("input", {
                  class: "me-2",
                  type: "checkbox",
                  checked: kycInfos.value.idType == '1'
                }, null, 8, _hoisted_255),
                _hoisted_256
              ])
            ])
          ])
        ]),
        _hoisted_257,
        _hoisted_258,
        _hoisted_259,
        _hoisted_260,
        _hoisted_261
      ])
    ]),
    _: 1
  }, 8, ["is-loading", "saveTitle"]))
}
}

})